import React from "react";

import { useTranslation } from "react-i18next";
import {
	FrontendCompanyTestResultField,
	FrontendUserInfo,
} from "node-library/dist/portal";

import { Card } from "@mui/material";

import { formatCustomDate } from "node-library/dist/helpers/date_helper";
import { SystemRole } from "node-library/dist/constants";

interface Props {
	result: FrontendCompanyTestResultField;
	goToViewResultDetails: () => void;
	// discardUnstartedOrder: () => void;
	packageNames: string[];
}

export default function ResultCell(props: Props) {
	const { t: translation } = useTranslation();

	const {
		goToViewResultDetails,
		result,
		// discardUnstartedOrder,
	} = props;

	let actionOptions: Array<{
		key: string;
		onClick: () => void;
		children: React.ReactNode;
	}>;

	const userHeaderRow: React.ReactNode = (
		<div
			style={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				gap: "5px",
			}}
		>
			{/* <KebabDropdownButton
				menuOptions={actionOptions}
				id={`batch-more-action-menu-${order.orderBarcodeId}`}
				onClick={(e) => {}}
			></KebabDropdownButton> */}
		</div>
	);
	const userBody: React.ReactNode = (
		<div
			style={{
				marginTop: "10px",
				display: "flex",
				flexDirection: "column",
				gap: "5px",
			}}
		>
			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("FieldName")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{result.fieldName}
				</div>
			</div>
			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("FieldType")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{result.fieldType}
				</div>
			</div>
			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("Units")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{result.availableUnits
						.map((unit) => {
							return unit.unit;
						})
						.join(", ") || translation("None")}
				</div>
			</div>

			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("ExpectationField")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{result.expectationField ? translation("Yes") : translation("None")}
				</div>
			</div>

			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("NodePackages")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{props.packageNames.length > 0
						? props.packageNames.join(", ")
						: translation("None")}
				</div>
			</div>

			{/* <div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("CreatedOn")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{formatCustomDate(result.inserted as Date)}
				</div>
			</div> */}
			{/* <div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("Receivedon")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{order.registered ? formatCustomDate(order.registered) : "--"}
				</div>
			</div> */}
		</div>
	);

	return (
		<Card
			className="card-border-radius-14p card-medium-padding highlight-card"
			style={{ cursor: "pointer" }}
			key={result.fieldId}
			onClick={() => {
				goToViewResultDetails();
			}}
		>
			{userHeaderRow}
			{userBody}
		</Card>
	);
}
